export default function formatCurrency(amount) {
  const num = Number(amount);
  return `R${Number.isNaN(num) ? '0.00' : num.toFixed(2)}`;
}
